import { type DOMNode, domToReact } from 'html-react-parser';
import type { CSSProperties } from 'react';

type Props = {
  number: string;
  className?: string;
  elementsToRender: DOMNode[];
  style?: CSSProperties;
};

export const PhoneTo = (props: Props) => {
  const { number } = props;
  const cleanedNumber = number.replace(/[\(\) -]/g, '');
  return (
    <a
      href={`tel:${cleanedNumber}`}
      aria-label={`Link to phone app ${cleanedNumber}`}
      className={`phoneto ${props.className || ''}`}
      style={props.style}
    >
      {domToReact(props.elementsToRender)}
    </a>
  );
};

export default PhoneTo;
